import { prepHandleEvent } from "./prepHandleEvent";
import { EventToCanvas } from "./EventToCanvas";

export function handleMouseDown(canvas) {
  return function (event) {
    var rect = canvas.getBoundingClientRect();

    if (event.button != 0)
      // Right click
      return;
    var p = EventToCanvas(event, rect.left, rect.top);

    //inputElement.style.visibility = 'hidden'; // hide it again

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;
    myApp.HandleMouseDown(p.x, p.y);
  };
}
